<template>
  <BaseModal
    v-bind="modalProps"
    @close="onCancel"
  >
    <template #content>
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="confirm-modal-content body-m-regular"
        v-html="content"
      />
      <!-- eslint-enable vue/no-v-html -->
    </template>
    <template #buttons>
      <div class="button-row">
        <BaseButton
          v-bind="cancelButtonProps"
          @click="onCancel"
        />
        <BaseButton
          v-bind="confirmButtonProps"
          @click="onConfirm"
        />
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue'
import BaseButton from './BaseButton.vue'

export default {
  name: 'ConfirmationModal',
  components: {
    BaseModal,
    BaseButton,
  },
  props: {
    modalProps: {
      type: Object,
      default: () => ({}),
    },
    confirmButtonProps: {
      type: Object,
      default: () => ({}),
    },
    cancelButtonProps: {
      type: Object,
      default: () => ({}),
    },
    content: {
      type: String,
      default: '',
    },
    onConfirm: {
      type: Function,
      default: () => {},
    },
    onCancel: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style scoped>
button {
  margin: unset;
}
:deep(a) {
  text-decoration: none;
  color: var(--blueberry-1000);
}
.button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.confirm-modal-content {
  width: 400px;
  padding: var(--space-2) 0;
}
</style>
